// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mVKZ","colMin":"styles_colMin__2KMVc"};